import { AsyncPipe, NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AddressSuggestionsSelectComponent } from '@sdvor/delivery/ui/v2';
import {
  FormFieldComponent,
  ModalComponent,
  SdvorButtonComponent,
  TodayTomorrowDatePipeModule,
  UrlMediaPipe,
} from '@sdvor/shared/ui';
import { YandexMapModule } from '@sdvor/yandex-maps/ui';
import { ShopListModule, ShopWorkingTimeModule, ShopsMapModule } from '@shop/ui';
import { IconModule } from '@spartacus/storefront';
import { SdvorPickupActiveShopSchemeModalComponent } from './pickup-active-shop-scheme-modal';
import { SdvorPickupActiveShopComponent } from './pickup-active-shop/pickup-active-shop.component';
import { SdvorPickupAddShopComponent } from './pickup-add-shop/pickup-add-shop.component';
import { SdvorPickupAddressComponent } from './pickup-address.component';
import { SdvorPickupChangeShopButtonComponent } from './pickup-change-shop-button/pickup-change-shop-button.component';
import { SdvorPickupInfoComponent } from './pickup-info/pickup-info.component';
import { SdvorPickupMapSelectPosComponent } from './pickup-map-select-pos/pickup-map-select-pos.component';
import { SdvorPickupShopListDesktopListComponent } from './pickup-shop-list/desktop/list/pickup-shop-list-desktop-list.component';
import { SdvorPickupShopListDesktopComponent } from './pickup-shop-list/desktop/pickup-shop-list-desktop.component';
import { SdvorPickupShopListDesktopSingleComponent } from './pickup-shop-list/desktop/single/pickup-shop-list-desktop-single.component';
import { SdvorPickupShopListMobileComponent } from './pickup-shop-list/mobile/pickup-shop-list-mobile.component';
import { SdvorPickupShopComponent } from './pickup-shop/pickup-shop.component';
import { SdvorPickupUserShopListModalComponent } from './pickup-user-shop-list-modal/pickup-user-shop-list-modal.component';
import { SdvorPickupUserShopListComponent } from './pickup-user-shop-list/pickup-user-shop-list.component';

@NgModule({
  declarations: [
    SdvorPickupAddressComponent,
    SdvorPickupInfoComponent,
    SdvorPickupShopComponent,
    SdvorPickupAddShopComponent,
    SdvorPickupActiveShopComponent,
    SdvorPickupMapSelectPosComponent,
    SdvorPickupShopListDesktopComponent,
    SdvorPickupShopListDesktopListComponent,
    SdvorPickupShopListDesktopSingleComponent,
    SdvorPickupShopListMobileComponent,
    SdvorPickupUserShopListComponent,
    SdvorPickupUserShopListModalComponent,
    SdvorPickupChangeShopButtonComponent,
    SdvorPickupActiveShopSchemeModalComponent,
  ],
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    UrlMediaPipe,
    NgClass,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    ReactiveFormsModule,
    IconModule,
    FormFieldComponent,
    ModalComponent,
    ShopWorkingTimeModule,
    YandexMapModule,
    ShopListModule,
    NgbTooltipModule,
    ShopsMapModule,
    TodayTomorrowDatePipeModule,
    SdvorButtonComponent,
    AddressSuggestionsSelectComponent,
  ],
  exports: [SdvorPickupAddressComponent],
})
export class SdvorPickupAddressModule {}
